import type {PS} from '@wix/document-services-types'
import textThemes from '../textThemes/textThemes'
import _ from 'lodash'
import {coreUtils} from '@wix/santa-ds-libs'

const fontUtils = coreUtils.fontUtils.createFontUtils()

function setToTextTheme(ps: PS, index: number, val: string) {
    const textTheme = fontUtils.fontStringToTextTheme(val)
    textThemes.set(ps, index, textTheme)
}

function getFromTextTheme(ps: PS, index: number) {
    const textTheme = textThemes.get(ps, index)
    if (!textTheme) {
        return
    }
    return fontUtils.textThemeToFontString(textTheme)
}

function getAllFromTextTheme(ps: PS) {
    const allTextThemes = textThemes.getAll(ps)
    return _.map(allTextThemes, fontUtils.textThemeToFontString)
}

export default {
    set: setToTextTheme,
    get: getFromTextTheme,
    getAll: getAllFromTextTheme
}
